const shellPrefs = {
  title: "Настройки рамки",
  sidebarHover: "Боковая панель при наведении",
  sidebarWidth: "Ширина боковой панели",
  topbarVisible: "Показать верхнюю панель",
  topbarHover: "Верхняя панель при наведении",
  tabbarVisible: "Показать панель вкладок",
  trayVisible: "Показать рабочий лоток",
  speedDialVisible: "Показать быстрый набор",
  hoverHint: "Появляется при наведении на край",
  resetDefaults: "Сбросить по умолчанию",
} as const;
export default shellPrefs;
